import React from 'react'
import { Link } from 'react-router-dom'
import ReadMore from '../Common/ReadMore'
import Slider from "react-slick";
import { getImages } from '../const';

const SrpMdBox = ({ item, index, numberFormatter, priceFormatter }) => {

    const optionssl = {
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true
    };
    // console.log("item Latest Drop", item)
    return (
        <>
            <div className='col-lg-8 col-md-12 col-12' key={index}>
                <div className='pro-box pro-full-width'>
                    <div className='before-hover d-flex align-items-center p-0'>
                        <div className='pro-bottom p-md-4 p-4'>
                            <div className='pb-logo mb-md-4 mb-2'>
                                <img src={getImages('mclaren-orlando-logo-white.png')} />
                            </div>
                            <div className='lg-title text-uppercase mb-2 text-theme'>Lease Special</div>
                            <div className="xs-title font-1em mb-md-3 mb-2">{item.vehicle_name}</div>
                            {item.inventory_manage.price_per_month > 0 ? <div className='d-flex align-items-end'>
                                <div className="sm-title">{numberFormatter(item.inventory_manage.price_per_month, true)}</div> 
                                <div className='xs-title opacity-0-5 font-0-9em pb-2 ps-2'>Per Month</div>
                            </div> : <a href='tel:4079880111' className='xs-title text-white'>CALL FOR PRICE</a>}
                            <div className='font-0-8em xs-title mt-3 mt-md-5 pt-0'>{item.inventory_manage.description}</div>
                            <div className="srp-disclaimer">{item.inventory_manage.disclaimer}</div>
                        </div>
                        <div className='pro-top position-relative'>
                            {item.images && item.images.length > 0 && <img src={item.images[0]} alt='srp' /> }
                            <Link to={"/vehicle-details/" + item.vdp_url} className="theme-btn text-uppercase fw-bold" >Vehicle Details</Link>
                        </div>
                    </div>
                    {/* <div className='pro-content'>
                        <div className='before-hover d-flex align-items-center'>
                            <div className='pro-top order-md-2'>
                                <img src={item.images[0]} alt='srp' />
                            </div>
                            <div className='pro-bottom p-0 ps-4'>
                                <div className='lt-main-title text-uppercase mb-4'>Latest Drop</div>
                                <div className="sm-title mb-2">{item.vehicle_name}</div>
                                <div className='d-flex align-items-center justify-content-between mt-5'>
                                    <div className='d-flex align-items-center'>
                                        <div className="xs-title pe-3">Price:</div>
                                        <div className="sm-title">{numberFormatter(item.price, true)}</div>
                                    </div>
                                    <div>
                                        <div className="xs-title">Mileage: {numberFormatter(item.mileage)}</div>
                                    </div>
                                </div>
                                <div className='mt-4 text-center'>
                                    <button className='green-btn w-100' type='button'>Vehicle Details</button>
                                </div>
                            </div>
                        </div>
                        <div className='after-hover d-flex align-items-center'>
                            <div className='pro-top'>
                                <Slider
                                    className="featured-slider"
                                    {...optionssl}
                                >
                                    {item.images.slice(0, 3).map((v, i) => {
                                        return (
                                            <div className='item' key={i}>
                                                <img src={v} alt='srp' />
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                            <div className='pro-bottom'>
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <div className='d-flex align-items-center w-60'>
                                        <div className='xs-title fw-400 w-30'>Stock #</div>
                                        <div className='sm-title w-70'>{item.stockno}</div>
                                    </div>
                                    <div className='d-flex align-items-center w-40'>
                                        <div className='xs-title fw-400 w-60'>Interior Color</div>
                                        <div className='sm-title w-40'>{item.interior_color}</div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <div className='d-flex align-items-center w-60'>
                                        <div className='xs-title fw-400 w-30'>VIN</div>
                                        <div className='sm-title w-70'>{item.vin}</div>
                                    </div>
                                    <div className='d-flex align-items-center w-40'>
                                        <div className='xs-title fw-400 w-60'>Exterior Color</div>
                                        <div className='sm-title w-40'>{item.exterior_color}</div>
                                    </div>
                                </div>
                                <hr className='custom-hr' />
                                <ReadMore
                                    key={index}
                                    text={item.description}
                                    maxChars={230}
                                    sectionId="aboutVdp"
                                    readMoreUrl={item.vdp_url}
                                />
                                <div className="d-flex align-items-center justify-content-between mt-4 pt-2 srp-actions-flex">
                                    <div>
                                        <button type='button' className='view-sticker-btn text-green'><span className='doc_icon'></span> View Window Sticker</button>
                                    </div>
                                    <div><a className="green-btn" href={item.vdp_url} >Vehicle Details</a></div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default SrpMdBox